/* ==========================================================================
   CRIMP'S CARD STORE — storefront behaviour
   No dependencies. Everything degrades to a working link or form.
   ========================================================================== */

(function () {
  'use strict';

  var root = document.documentElement;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var isMobile = function () { return window.matchMedia('(max-width: 899px)').matches; };

  /* ------------------------------------------------------------- helpers -- */

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function on(el, ev, fn, opt) { if (el) el.addEventListener(ev, fn, opt); }

  function debounce(fn, ms) {
    var t;
    return function () {
      var a = arguments, c = this;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(c, a); }, ms);
    };
  }

  var scrollLocks = 0;
  function lockScroll(lock) {
    scrollLocks = Math.max(0, scrollLocks + (lock ? 1 : -1));
    document.body.classList.toggle('is-locked', scrollLocks > 0);
  }

  /* Trap focus inside an open overlay so keyboard users stay put. */
  function trap(panel) {
    function keys(e) {
      if (e.key !== 'Tab') return;
      var f = $$('a[href], button:not([disabled]), input:not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])', panel)
        .filter(function (el) { return el.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
    panel.addEventListener('keydown', keys);
    return function () { panel.removeEventListener('keydown', keys); };
  }

  /* --------------------------------------------------------------- toasts -- */

  var ICON_OK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>';
  var ICON_ERR = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>';

  function toast(msg, kind) {
    var host = $('.toasts');
    if (!host) {
      host = document.createElement('div');
      host.className = 'toasts';
      document.body.appendChild(host);
    }
    var t = document.createElement('div');
    t.className = 'toast toast--' + (kind === 'err' ? 'err' : 'ok');
    t.setAttribute('role', 'status');
    t.innerHTML = (kind === 'err' ? ICON_ERR : ICON_OK) + '<span></span>';
    $('span', t).textContent = msg;
    host.appendChild(t);
    setTimeout(function () {
      t.classList.add('is-out');
      setTimeout(function () { t.remove(); }, 320);
    }, 3600);
  }
  window.CrimpsToast = toast;

  /* --------------------------------------------------------------- header -- */

  (function header() {
    var hdr = $('.hdr');
    if (!hdr) return;
    var bar = $('.scrollbar');
    var last = -1;

    function frame() {
      var y = window.scrollY || 0;
      if (y !== last) {
        hdr.classList.toggle('is-stuck', y > 6);
        if (bar) {
          var h = document.documentElement.scrollHeight - window.innerHeight;
          bar.style.width = (h > 0 ? (y / h) * 100 : 0) + '%';
        }
        last = y;
      }
      requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
  })();

  /* ---------------------------------------------------------- mobile menu -- */

  (function mobileNav() {
    var nav = $('.mnav');
    if (!nav) return;
    var release;

    function open() {
      nav.setAttribute('aria-hidden', 'false');
      lockScroll(true);
      release = trap(nav);
      var f = $('.mnav__link', nav);
      if (f) setTimeout(function () { f.focus(); }, 120);
    }
    function close() {
      nav.setAttribute('aria-hidden', 'true');
      lockScroll(false);
      if (release) { release(); release = null; }
    }

    $$('[data-mnav-open]').forEach(function (b) { on(b, 'click', open); });
    $$('[data-mnav-close]').forEach(function (b) { on(b, 'click', close); });
    on(nav, 'click', function (e) { if (e.target === $('.mnav__scrim', nav)) close(); });
    on(document, 'keydown', function (e) {
      if (e.key === 'Escape' && nav.getAttribute('aria-hidden') === 'false') close();
    });
  })();

  /* ----------------------------------------------------- predictive search -- */

  (function search() {
    var ov = $('.searchov');
    if (!ov) return;
    var input = $('input[name="q"]', ov);
    var out = $('.searchov__results', ov);
    var all = $('.searchov__all', ov);
    var release, controller;

    function open() {
      ov.setAttribute('aria-hidden', 'false');
      lockScroll(true);
      release = trap(ov);
      setTimeout(function () { input.focus(); input.select(); }, 120);
    }
    function close() {
      ov.setAttribute('aria-hidden', 'true');
      lockScroll(false);
      if (release) { release(); release = null; }
    }

    $$('[data-search-open]').forEach(function (b) { on(b, 'click', function (e) { e.preventDefault(); open(); }); });
    $$('[data-search-close]').forEach(function (b) { on(b, 'click', close); });
    on(ov, 'click', function (e) { if (e.target === $('.searchov__scrim', ov)) close(); });
    on(document, 'keydown', function (e) {
      if (e.key === 'Escape' && ov.getAttribute('aria-hidden') === 'false') close();
      /* Cmd/Ctrl+K opens search, like the tools people already use. */
      if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'k') { e.preventDefault(); open(); }
    });

    function esc(s) {
      return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    function conditionOf(p) {
      /* Predictive search returns tags; condition:* is our fallback convention. */
      var tags = p.tags || [];
      for (var i = 0; i < tags.length; i++) {
        var m = /^condition\s*:\s*(.+)$/i.exec(tags[i]);
        if (m) return m[1].trim();
      }
      return '';
    }

    function render(products, q) {
      if (!products.length) {
        out.innerHTML = '<div class="searchov__empty">No cards matching &ldquo;' + esc(q) + '&rdquo;.</div>';
        if (all) all.hidden = true;
        return;
      }
      out.innerHTML = products.map(function (p) {
        var img = p.featured_image && p.featured_image.url ? p.featured_image.url : (p.image || '');
        var cond = conditionOf(p);
        var meta = [cond, p.vendor && p.vendor !== 'CRIMP’S' ? p.vendor : ''].filter(Boolean).join(' · ');
        return '<a class="sres" href="' + esc(p.url) + '">' +
          '<span class="sres__img">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy" width="44" height="62">' : '') + '</span>' +
          '<span class="sres__t"><span class="sres__n">' + esc(p.title) + '</span>' +
          (meta ? '<span class="sres__m">' + esc(meta) + '</span>' : '') + '</span>' +
          '<span class="sres__p">' + (p.available === false ? 'Sold' : esc(p.price || '')) + '</span>' +
          '</a>';
      }).join('');
      if (all) {
        all.hidden = false;
        all.href = '/search?q=' + encodeURIComponent(q) + '&type=product';
      }
    }

    var run = debounce(function () {
      var q = input.value.trim();
      if (q.length < 2) {
        out.innerHTML = '<div class="searchov__hint">Type a Pokémon, set or card number.</div>';
        if (all) all.hidden = true;
        return;
      }
      out.innerHTML = '<div class="searchov__empty"><span class="spinner" style="margin:0 auto"></span></div>';
      if (controller) controller.abort();
      controller = typeof AbortController !== 'undefined' ? new AbortController() : null;

      var url = '/search/suggest.json?q=' + encodeURIComponent(q) +
        '&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,vendor,tag,variants.sku';

      fetch(url, controller ? { signal: controller.signal } : undefined)
        .then(function (r) { return r.json(); })
        .then(function (d) {
          var items = (d.resources && d.resources.results && d.resources.results.products) || [];
          render(items.map(function (p) {
            return {
              title: p.title, url: p.url, vendor: p.vendor, tags: p.tags,
              featured_image: p.featured_image, image: p.image,
              price: p.price ? p.price : '', available: p.available
            };
          }), q);
        })
        .catch(function (err) {
          if (err && err.name === 'AbortError') return;
          out.innerHTML = '<div class="searchov__empty">Search is unavailable right now. <a href="/search?q=' + encodeURIComponent(q) + '" style="text-decoration:underline">Open full search</a>.</div>';
        });
    }, 180);

    on(input, 'input', run);

    /* Arrow keys walk the results; Enter opens the highlighted one. */
    on(input, 'keydown', function (e) {
      if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp' && e.key !== 'Enter') return;
      var items = $$('.sres', out);
      if (!items.length) return;
      var idx = items.findIndex(function (el) { return el.classList.contains('is-active'); });
      if (e.key === 'Enter') {
        if (idx > -1) { e.preventDefault(); items[idx].click(); }
        return;
      }
      e.preventDefault();
      if (idx > -1) items[idx].classList.remove('is-active');
      idx = e.key === 'ArrowDown' ? (idx + 1) % items.length : (idx <= 0 ? items.length - 1 : idx - 1);
      items[idx].classList.add('is-active');
      items[idx].scrollIntoView({ block: 'nearest' });
    });
  })();

  /* ----------------------------------------------------------------- cart -- */

  var Cart = (function () {
    var drawer = $('.cart');
    var release;

    function setCount(n) {
      $$('[data-cart-count]').forEach(function (el) {
        el.textContent = n > 99 ? '99+' : n;
        el.hidden = !n;
      });
    }

    function open() {
      if (!drawer) return;
      drawer.setAttribute('aria-hidden', 'false');
      lockScroll(true);
      release = trap(drawer);
    }
    function close() {
      if (!drawer) return;
      drawer.setAttribute('aria-hidden', 'true');
      lockScroll(false);
      if (release) { release(); release = null; }
    }

    /* Swap the drawer contents with freshly rendered Liquid. */
    function paint(sections) {
      if (!drawer || !sections) return;
      var key = Object.keys(sections)[0];
      var html = sections['cart-drawer'] || sections[key];
      if (!html) return;
      var tmp = document.createElement('div');
      tmp.innerHTML = html;
      var fresh = $('[data-cart-inner]', tmp);
      var live = $('[data-cart-inner]', drawer);
      if (fresh && live) {
        live.innerHTML = fresh.innerHTML;
        var n = parseInt(fresh.getAttribute('data-count') || '0', 10);
        setCount(isNaN(n) ? 0 : n);
      }
    }

    function refresh() {
      return fetch('/?sections=cart-drawer')
        .then(function (r) { return r.json(); })
        .then(paint)
        .catch(function () {});
    }

    function add(id, qty, btn) {
      if (btn) { btn.classList.add('is-busy'); btn.setAttribute('aria-disabled', 'true'); }
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: id, quantity: qty || 1 }], sections: 'cart-drawer' })
      })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
        .then(function (res) {
          if (!res.ok) {
            /* Shopify rejects over-ordering of one-of-one stock. Say so plainly. */
            var msg = res.d && res.d.description ? res.d.description : 'That card is no longer available.';
            toast(msg.replace(/<[^>]+>/g, ''), 'err');
            return refresh();
          }
          paint(res.d.sections);
          if (!res.d.sections) refresh();
          open();
          return null;
        })
        .catch(function () { toast('Could not reach the cart. Please try again.', 'err'); })
        .finally(function () {
          if (btn) { btn.classList.remove('is-busy'); btn.removeAttribute('aria-disabled'); }
        });
    }

    function change(key, qty, row) {
      if (row) row.classList.add('is-going');
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty, sections: 'cart-drawer' })
      })
        .then(function (r) { return r.json(); })
        .then(function (d) {
          paint(d.sections);
          if (!d.sections) refresh();
          if (document.body.classList.contains('tmpl-cart')) window.location.reload();
        })
        .catch(function () {
          if (row) row.classList.remove('is-going');
          toast('Could not update the cart.', 'err');
        });
    }

    if (drawer) {
      $$('[data-cart-open]').forEach(function (b) {
        on(b, 'click', function (e) { e.preventDefault(); open(); });
      });
      on(drawer, 'click', function (e) {
        if (e.target === $('.cart__scrim', drawer)) close();
        if (e.target.closest('[data-cart-close]')) close();
        var q = e.target.closest('[data-qty]');
        if (q) {
          var row = q.closest('.citem');
          change(q.getAttribute('data-key'), parseInt(q.getAttribute('data-qty'), 10), row);
        }
        var rm = e.target.closest('[data-remove]');
        if (rm) {
          var r2 = rm.closest('.citem');
          change(rm.getAttribute('data-key'), 0, r2);
        }
      });
      on(document, 'keydown', function (e) {
        if (e.key === 'Escape' && drawer.getAttribute('aria-hidden') === 'false') close();
      });

      /* Bottom-sheet swipe-down to close on phones. */
      swipeToDismiss($('.cart__panel', drawer), close, function () { return isMobile(); });
    }

    /* The cart page uses the same controls, outside the drawer. */
    on(document, 'click', function (e) {
      if (e.target.closest('.cart')) return;
      var q = e.target.closest('[data-qty]');
      if (q) {
        e.preventDefault();
        change(q.getAttribute('data-key'), parseInt(q.getAttribute('data-qty'), 10), q.closest('.coline'));
        return;
      }
      var rm = e.target.closest('[data-remove]');
      if (rm) {
        e.preventDefault();
        change(rm.getAttribute('data-key'), 0, rm.closest('.coline'));
      }
    });

    /* Intercept every add-to-cart form so nobody leaves the page. */
    $$('form[action*="/cart/add"]').forEach(function (form) {
      on(form, 'submit', function (e) {
        if (!drawer) return;
        e.preventDefault();
        var idEl = form.querySelector('[name="id"]');
        var qEl = form.querySelector('[name="quantity"]');
        if (!idEl || !idEl.value) return;
        add(parseInt(idEl.value, 10), qEl ? parseInt(qEl.value, 10) || 1 : 1, form.querySelector('[type="submit"]'));
      });
    });

    return { open: open, close: close, add: add, change: change, refresh: refresh };
  })();
  window.CrimpsCart = Cart;

  /* --------------------------------------------------- swipe-to-dismiss -- */

  function swipeToDismiss(panel, onDismiss, when) {
    if (!panel) return;
    var y0 = 0, dy = 0, dragging = false, scroller = null;

    function start(e) {
      if (when && !when()) return;
      var t = e.touches[0];
      /* Only start a drag from the handle or when the inner list is at the top. */
      scroller = e.target.closest('.drawer__body, .searchov__results');
      if (scroller && scroller.scrollTop > 2 && !e.target.closest('.sheet__handle, .drawer__head, .promo__grab')) return;
      y0 = t.clientY; dy = 0; dragging = true;
      panel.style.transition = 'none';
    }
    function move(e) {
      if (!dragging) return;
      dy = e.touches[0].clientY - y0;
      if (dy < 0) { if (scroller) { dragging = false; panel.style.transition = ''; panel.style.transform = ''; return; } dy = dy * 0.25; }
      panel.style.transform = 'translateY(' + dy + 'px)';
    }
    function end() {
      if (!dragging) return;
      dragging = false;
      panel.style.transition = '';
      panel.style.transform = '';
      if (dy > Math.min(140, panel.offsetHeight * 0.28)) onDismiss();
    }

    panel.addEventListener('touchstart', start, { passive: true });
    panel.addEventListener('touchmove', move, { passive: true });
    panel.addEventListener('touchend', end);
    panel.addEventListener('touchcancel', end);
  }

  /* ---------------------------------------------------------- promo sheet -- */

  (function promo() {
    var el = $('.promo');
    if (!el) return;

    var KEY = 'crimps:drop:' + (el.getAttribute('data-version') || '1');
    var seen = false;
    try { seen = sessionStorage.getItem(KEY) === '1'; } catch (e) { seen = false; }

    /* Never on the clothing pages — they are already there. */
    if (seen || el.hasAttribute('data-suppress')) { el.remove(); return; }

    function remember() {
      try { sessionStorage.setItem(KEY, '1'); } catch (e) {}
    }

    function show() {
      el.classList.add('is-open');
      remember();
    }
    function hide() {
      el.classList.remove('is-open');
      remember();
      setTimeout(function () { el.remove(); }, 700);
    }

    var delay = parseFloat(el.getAttribute('data-delay') || '3') * 1000;
    setTimeout(show, reduced ? 400 : delay);

    $$('[data-promo-close]', el).forEach(function (b) { on(b, 'click', hide); });
    on(document, 'keydown', function (e) {
      if (e.key === 'Escape' && el.classList.contains('is-open')) hide();
    });
    /* Any click through to the collection also retires the panel. */
    $$('a', el).forEach(function (a) { on(a, 'click', remember); });

    /* Swipe the sheet down (or flick it up) to dismiss. */
    var sheet = $('.promo__sheet', el);
    var y0 = 0, dy = 0, drag = false;
    if (sheet) {
      sheet.addEventListener('touchstart', function (e) {
        y0 = e.touches[0].clientY; dy = 0; drag = true;
        el.classList.add('is-dragging');
      }, { passive: true });
      sheet.addEventListener('touchmove', function (e) {
        if (!drag) return;
        dy = e.touches[0].clientY - y0;
        sheet.style.transform = 'translateY(' + dy + 'px)';
      }, { passive: true });
      sheet.addEventListener('touchend', function () {
        if (!drag) return;
        drag = false;
        el.classList.remove('is-dragging');
        sheet.style.transform = '';
        if (Math.abs(dy) > 56) hide();
      });
    }
  })();

  /* -------------------------------------------------------- product media -- */

  (function gallery() {
    var gal = $('.gal');
    if (!gal) return;

    var stage = $('.gal__stage', gal);
    var slides = $$('img', stage);
    var thumbs = $$('.gal__thumb', gal);
    var i = 0;

    function go(n) {
      if (!slides.length) return;
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
      thumbs.forEach(function (t, k) {
        t.classList.toggle('is-active', k === i);
        t.setAttribute('aria-selected', k === i ? 'true' : 'false');
      });
    }

    thumbs.forEach(function (t, k) {
      on(t, 'click', function (e) { e.preventDefault(); go(k); });
      on(t, 'mouseenter', function () { if (!isMobile()) go(k); });
    });

    /* Lightbox: click to open, wheel/pinch to zoom, drag to pan. */
    var lb = $('.lbox');
    if (!lb) return;
    var lbImg = $('.lbox__img', lb);
    var lbNum = $('.lbox__bar .mono', lb);
    var scale = 1, tx = 0, ty = 0;

    function apply() {
      lbImg.style.transform = 'translate(' + tx + 'px,' + ty + 'px) scale(' + scale + ')';
      lbImg.classList.toggle('is-zoomed', scale > 1.01);
    }
    function reset() { scale = 1; tx = 0; ty = 0; apply(); }

    function openLb(n) {
      go(n);
      lbImg.src = slides[i].getAttribute('data-full') || slides[i].currentSrc || slides[i].src;
      lbImg.alt = slides[i].alt || '';
      if (lbNum) lbNum.textContent = (i + 1) + ' / ' + slides.length;
      lb.setAttribute('aria-hidden', 'false');
      lockScroll(true);
      reset();
    }
    function closeLb() {
      lb.setAttribute('aria-hidden', 'true');
      lockScroll(false);
    }

    on(stage, 'click', function () { openLb(i); });
    $$('[data-lbox-close]', lb).forEach(function (b) { on(b, 'click', closeLb); });
    on(lb, 'click', function (e) { if (e.target === lb) closeLb(); });

    on($('.lbox__nav--prev', lb), 'click', function (e) { e.stopPropagation(); openLb(i - 1); });
    on($('.lbox__nav--next', lb), 'click', function (e) { e.stopPropagation(); openLb(i + 1); });

    on(document, 'keydown', function (e) {
      if (lb.getAttribute('aria-hidden') !== 'false') return;
      if (e.key === 'Escape') closeLb();
      if (e.key === 'ArrowLeft') openLb(i - 1);
      if (e.key === 'ArrowRight') openLb(i + 1);
    });

    on(lb, 'wheel', function (e) {
      e.preventDefault();
      scale = Math.min(5, Math.max(1, scale + (e.deltaY < 0 ? 0.22 : -0.22)));
      if (scale === 1) { tx = 0; ty = 0; }
      apply();
    }, { passive: false });

    on(lbImg, 'dblclick', function (e) {
      e.stopPropagation();
      scale = scale > 1.01 ? 1 : 2.6;
      tx = 0; ty = 0;
      apply();
    });

    /* Mouse pan */
    var panning = false, px = 0, py = 0;
    on(lbImg, 'mousedown', function (e) {
      if (scale <= 1.01) return;
      e.preventDefault();
      panning = true; px = e.clientX - tx; py = e.clientY - ty;
    });
    on(window, 'mousemove', function (e) {
      if (!panning) return;
      tx = e.clientX - px; ty = e.clientY - py; apply();
    });
    on(window, 'mouseup', function () { panning = false; });

    /* Touch: one finger pans when zoomed, swipes between images when not. */
    var t0 = null, pinch0 = 0, scale0 = 1;
    function dist(t) {
      var dx = t[0].clientX - t[1].clientX, dy = t[0].clientY - t[1].clientY;
      return Math.sqrt(dx * dx + dy * dy);
    }
    lb.addEventListener('touchstart', function (e) {
      if (e.touches.length === 2) { pinch0 = dist(e.touches); scale0 = scale; t0 = null; }
      else if (e.touches.length === 1) { t0 = { x: e.touches[0].clientX, y: e.touches[0].clientY, tx: tx, ty: ty }; }
    }, { passive: true });

    lb.addEventListener('touchmove', function (e) {
      if (e.touches.length === 2 && pinch0) {
        scale = Math.min(5, Math.max(1, scale0 * (dist(e.touches) / pinch0)));
        if (scale === 1) { tx = 0; ty = 0; }
        apply();
      } else if (e.touches.length === 1 && t0 && scale > 1.01) {
        tx = t0.tx + (e.touches[0].clientX - t0.x);
        ty = t0.ty + (e.touches[0].clientY - t0.y);
        apply();
      }
    }, { passive: true });

    lb.addEventListener('touchend', function (e) {
      if (t0 && scale <= 1.01 && e.changedTouches.length) {
        var dx = e.changedTouches[0].clientX - t0.x;
        var dy = Math.abs(e.changedTouches[0].clientY - t0.y);
        if (Math.abs(dx) > 56 && dy < 70) openLb(i + (dx < 0 ? 1 : -1));
        else if (dy > 90) closeLb();
      }
      pinch0 = 0; t0 = null;
    });
  })();

  /* ------------------------------------------------------- variant picker -- */

  (function variants() {
    $$('[data-variants]').forEach(function (form) {
      var data;
      try { data = JSON.parse($('[data-variant-json]', form).textContent); } catch (e) { return; }
      var idInput = $('[name="id"]', form);
      var priceEl = $('[data-variant-price]', form);
      var btn = $('[data-add]', form);
      var stockEl = $('[data-variant-stock]', form);
      var money = form.getAttribute('data-money') || '${{amount}}';

      function fmt(cents) {
        var v = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        return money.replace(/\{\{\s*amount\s*\}\}/, v).replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100));
      }

      function pick(v) {
        if (!v) return;
        if (idInput) idInput.value = v.id;
        if (priceEl) priceEl.textContent = fmt(v.price);
        if (btn) {
          btn.disabled = !v.available;
          $('span', btn).textContent = v.available ? (btn.getAttribute('data-label') || 'ADD TO CART') : 'SOLD OUT';
        }
        if (stockEl) {
          stockEl.textContent = v.available
            ? (v.inventory_quantity === 1 ? 'One available' : 'In stock')
            : 'Sold out';
          stockEl.parentElement.classList.toggle('stock--out', !v.available);
        }
        if (history.replaceState) {
          var u = new URL(window.location.href);
          u.searchParams.set('variant', v.id);
          history.replaceState({}, '', u);
        }
      }

      $$('.size input', form).forEach(function (inp) {
        on(inp, 'change', function () {
          $$('.size', form).forEach(function (l) { l.classList.remove('is-active'); });
          inp.closest('.size').classList.add('is-active');
          pick(data.filter(function (v) { return String(v.id) === inp.value; })[0]);
        });
      });

      var checked = $('.size input:checked', form);
      if (checked) pick(data.filter(function (v) { return String(v.id) === checked.value; })[0]);
    });
  })();

  /* -------------------------------------------------------------- filters -- */

  (function filters() {
    var dr = $('.fdrawer');
    if (dr) {
      var release;
      var open = function () {
        dr.setAttribute('aria-hidden', 'false');
        lockScroll(true);
        release = trap(dr);
      };
      var close = function () {
        dr.setAttribute('aria-hidden', 'true');
        lockScroll(false);
        if (release) { release(); release = null; }
      };
      $$('[data-filters-open]').forEach(function (b) { on(b, 'click', open); });
      $$('[data-filters-close]').forEach(function (b) { on(b, 'click', close); });
      on(dr, 'click', function (e) { if (e.target === $('.fdrawer__scrim', dr)) close(); });
      on(document, 'keydown', function (e) {
        if (e.key === 'Escape' && dr.getAttribute('aria-hidden') === 'false') close();
      });
      swipeToDismiss($('.fdrawer__panel', dr), close, function () { return isMobile(); });

      /* Checkboxes submit the facet form straight away. */
      var form = $('form[data-facets]', dr);
      if (form) {
        $$('input[type="checkbox"]', form).forEach(function (c) {
          on(c, 'change', function () { form.submit(); });
        });
      }
    }

    /* Sort: Shopify handles the price/date orders; condition is done here. */
    var sortSel = $('[data-sort]');
    if (sortSel) {
      on(sortSel, 'change', function () {
        var v = sortSel.value;
        if (v === 'condition') {
          sortByCondition();
          var u = new URL(window.location.href);
          u.searchParams.set('sort_by', 'condition');
          history.replaceState({}, '', u);
          return;
        }
        var base = sortSel.getAttribute('data-sort-base');
        var url = base ? new URL(base, window.location.origin) : new URL(window.location.href);
        url.searchParams.set('sort_by', v);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });

      if (new URLSearchParams(window.location.search).get('sort_by') === 'condition') sortByCondition();
    }

    function sortByCondition() {
      var grid = $('[data-grid]');
      if (!grid) return;
      var items = $$(':scope > *', grid);
      items.sort(function (a, b) {
        var ra = parseInt(a.getAttribute('data-cond-rank') || '99', 10);
        var rb = parseInt(b.getAttribute('data-cond-rank') || '99', 10);
        if (ra !== rb) return ra - rb;
        var pa = parseFloat(a.getAttribute('data-price') || '0');
        var pb = parseFloat(b.getAttribute('data-price') || '0');
        return pb - pa;
      });
      items.forEach(function (el) { grid.appendChild(el); });
    }
  })();

  /* --------------------------------------------- sold cards drift to the end -- */

  (function soldLast() {
    var grid = $('[data-grid][data-sold-last]');
    if (!grid) return;
    var sold = $$(':scope > [data-sold="1"]', grid);
    sold.forEach(function (el) { grid.appendChild(el); });
  })();

  /* ----------------------------------------------- search within the grid -- */
  /* Filters the cards already on the page as you type. Enter (or the link in
     the empty state) hands off to Shopify search, which covers every page. */

  (function gridSearch() {
    var input = $('[data-grid-search]');
    var grid = $('[data-grid]');
    if (!input || !grid) return;

    var clear = $('[data-grid-search-clear]');
    var countEl = $('.filters__count');
    var baseCount = countEl ? countEl.textContent.trim() : '';
    var searchAll = input.getAttribute('data-search-all') || '/search';
    var empty = null;

    function fullSearchUrl(q) {
      return searchAll + '?q=' + encodeURIComponent(q) + '&type=product';
    }

    function showEmpty(q) {
      if (!empty) {
        empty = document.createElement('div');
        empty.className = 'gsearch-empty';
        grid.appendChild(empty);
      }
      empty.innerHTML =
        '<strong></strong>' +
        '<p>Nothing on this page matches. The rest of the shop may still have it.</p>' +
        '<a href="' + fullSearchUrl(q) + '">Search the whole shop</a>';
      $('strong', empty).textContent = 'No match for \u201c' + q + '\u201d';
      empty.hidden = false;
    }

    function hideEmpty() { if (empty) empty.hidden = true; }

    function apply() {
      var q = input.value.trim().toLowerCase();
      var cards = $$('.card', grid);
      var shown = 0;

      cards.forEach(function (card) {
        var hay = card.getAttribute('data-search') || card.textContent.toLowerCase();
        var hit = !q || hay.indexOf(q) > -1;
        card.classList.toggle('is-searchhidden', !hit);
        if (hit) shown++;
      });

      if (clear) clear.hidden = !q;

      if (countEl) {
        countEl.textContent = q
          ? shown + ' match' + (shown === 1 ? '' : 'es')
          : baseCount;
      }

      if (q && shown === 0) showEmpty(input.value.trim());
      else hideEmpty();
    }

    on(input, 'input', debounce(apply, 110));

    on(input, 'keydown', function (e) {
      if (e.key === 'Escape') {
        input.value = '';
        apply();
        return;
      }
      if (e.key === 'Enter') {
        e.preventDefault();
        var q = input.value.trim();
        if (q) window.location.href = fullSearchUrl(q);
      }
    });

    if (clear) {
      on(clear, 'click', function () {
        input.value = '';
        apply();
        input.focus();
      });
    }

    /* Arriving from a full search? Prefill so the two stay consistent. */
    var incoming = new URLSearchParams(window.location.search).get('q');
    if (incoming) {
      input.value = incoming;
      apply();
    }
  })();

  /* -------------------------------------------------------- reveal on scroll -- */

  (function reveal() {
    var els = $$('.reveal');
    if (!els.length || reduced || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        en.target.classList.add('is-in');
        io.unobserve(en.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.04 });
    els.forEach(function (el) { io.observe(el); });
  })();

  /* ------------------------------------------------------ page transitions -- */

  (function transitions() {
    if (reduced || !('animate' in Element.prototype)) return;
    on(document, 'click', function (e) {
      var a = e.target.closest('a');
      if (!a) return;
      if (a.target === '_blank' || a.hasAttribute('download') || e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
      var href = a.getAttribute('href') || '';
      if (!href || href.charAt(0) === '#' || /^(mailto|tel|javascript):/i.test(href)) return;
      if (a.hostname && a.hostname !== window.location.hostname) return;
      if (a.closest('.cart, .searchov, .fdrawer')) return;
      if (href.indexOf('/checkout') === 0 || href.indexOf('/cart/') === 0) return;
      document.body.classList.add('is-leaving');
      setTimeout(function () { document.body.classList.remove('is-leaving'); }, 900);
    });
    on(window, 'pageshow', function () { document.body.classList.remove('is-leaving'); });
  })();

  /* --------------------------------------------- scan-line travel distance -- */

  (function scanFx() {
    var b = $('.banner');
    if (!b) return;
    var set = function () { b.style.setProperty('--scan-dist', b.offsetHeight + 'px'); };
    set();
    on(window, 'resize', debounce(set, 200));
  })();

  /* ------------------------------------------- lazy image fade-in on load -- */

  document.addEventListener('load', function (e) {
    var t = e.target;
    if (t && t.tagName === 'IMG' && t.hasAttribute('data-fade')) t.style.opacity = '1';
  }, true);

  root.classList.add('js-ready');
})();


/* ------------------------------------------------------ load more -- */
/*
  The card filter above a grid only searches cards that are actually in the
  page. On a paginated collection that meant it searched one page's worth
  while the pager underneath threw the typed query away on the way to page
  two. This swaps that pager for a button that pulls the next page in below
  the cards already there, so the filter covers everything loaded and you
  never lose your place. Self-contained on purpose: with JavaScript off the
  plain pager is left exactly as the template rendered it.
*/
(function () {
  'use strict';

  function q(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qa(sel, ctx) {
    return Array.prototype.slice.call((ctx || document).querySelectorAll(sel));
  }

  var grid = q('[data-grid]');
  var pager = q('.pager');
  if (!grid || !pager || !window.fetch || !window.DOMParser) return;

  /* Works with either pager shape the theme renders: the numbered link one
     past the current page, or the explicit next arrow. */
  function nextUrl(scope) {
    var p = scope.querySelector('.pager');
    if (!p) return null;

    var cur = p.querySelector('[aria-current="page"]');
    var n = cur ? parseInt(cur.textContent.trim(), 10) : NaN;
    if (!isNaN(n)) {
      var links = p.querySelectorAll('a[href]');
      for (var i = 0; i < links.length; i++) {
        if (parseInt(links[i].textContent.trim(), 10) === n + 1) {
          return links[i].getAttribute('href');
        }
      }
    }

    var arrow = p.querySelector('a[aria-label="Next page"]');
    return arrow ? arrow.getAttribute('href') : null;
  }

  var next = nextUrl(document);
  if (!next) return;

  /* Remember what is already on screen so a page we have seen cannot be
     appended twice. */
  var seen = {};
  qa('.card', grid).forEach(function (card) {
    seen[card.getAttribute('href')] = 1;
  });

  var LABEL = 'Load more cards';

  var wrap = document.createElement('div');
  wrap.className = 'loadmore';

  var btn = document.createElement('button');
  btn.type = 'button';
  btn.className = 'btn btn--ghost';
  btn.textContent = LABEL;

  wrap.appendChild(btn);
  pager.parentNode.insertBefore(wrap, pager);
  pager.hidden = true;

  var busy = false;

  btn.addEventListener('click', function () {
    if (busy || !next) return;
    busy = true;
    btn.disabled = true;
    btn.textContent = 'Loading…';

    fetch(next, { credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) throw new Error(res.status);
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var incoming = doc.querySelector('[data-grid]');

        if (incoming) {
          qa(':scope > *', incoming).forEach(function (el) {
            var href = el.getAttribute('href');
            if (href && seen[href]) return;
            if (href) seen[href] = 1;
            grid.appendChild(document.importNode(el, true));
          });
        }

        /* Sold cards stay at the end, the way the page was built. */
        if (grid.hasAttribute('data-sold-last')) {
          qa(':scope > [data-sold="1"]', grid).forEach(function (el) {
            grid.appendChild(el);
          });
        }

        /* Re-run the card filter so a query already typed in covers the
           cards that just arrived. */
        var input = q('[data-grid-search]');
        if (input && input.value.trim()) {
          input.dispatchEvent(new Event('input', { bubbles: true }));
        }

        next = nextUrl(doc);
        busy = false;

        if (next) {
          btn.disabled = false;
          btn.textContent = LABEL;
        } else {
          wrap.parentNode.removeChild(wrap);
        }
      })
      .catch(function () {
        /* Hand back the ordinary pager rather than leave a dead button. */
        busy = false;
        wrap.parentNode.removeChild(wrap);
        pager.hidden = false;
      });
  });
})();
